<template>
  <div class="public-title">
    <div>
      {{ title }}
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
.public-title{
  padding-top: 12px;
  height: 42px;
  font-size: 30px;
  font-weight: 600;
  color: #333333;
  line-height: 42px;
  display: flex;
  margin-bottom: 36px;
}
.public-title > div:first-of-type {
  flex-grow: 1;
}
</style>
